<mat-dialog-content>
  <h1 class="mb-2">{{ 'dialogs.gameover.gameover_title' | translate }}</h1>
  <p [innerHTML]="
    ('dialogs.gameover.gameover_text' | translate )">
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <eon-ui-button (click)="restartGame()" rank="secondary" scheme="{{eonUiScheme}}"
                 text="{{ 'dialogs.gameover.gameover_try_again' | translate}}"></eon-ui-button>
</mat-dialog-actions>
